export async function asyncIterablePipeline(source, ...stages) {
    // Chain generators by sending outdata from one to another
    let result = source(); // Start with the source generator
    for (let i = 0; i < stages.length; i++) {
        result = stages[i](result); // Pass on the result to next generator
    }
    // Start running the machine. If the last stage is a sink, it will consume the data and never emit anything
    // to us here...
    for await (const chunk of result) {
    }
}
